import React, { useEffect, useState } from "react";
import { Col, Row, Breadcrumb, Form, Card } from "react-bootstrap";
import axios from "axios";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from 'primereact/calendar';
import { Avatar } from 'primereact/avatar';
import { FaUserCheck, FaUserTimes } from "react-icons/fa";
import successVideo from '../../assets/video/paperplane.mp4';
import { Dialog } from "primereact/dialog";

const Add_employee_task = () => {
    const { accessToken, userId } = useAuth();
    const [users, setUsers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [selectedBrandId, setSelectedBrandId] = useState("");
    const [selectedProject, setSelectedProject] = useState("");
    const [projects, setProjects] = useState([]);
    const [selectedUserDetails, setSelectedUserDetails] = useState(null);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [validationMessage, setValidationMessage] = useState('');
    const [showValidationDialog, setShowValidationDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const createEmptyTaskForm = () => ({
        user_id: userId,
        task_name: "",
        task_description: "",
        task_startdate: "",
        task_deadline: "",
        task_type: "Graphe",
        priority: "Low",
        userDetails: null, // New field to store the selected user details
    });

    const [taskForms, setTaskForms] = useState([createEmptyTaskForm()]);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const usersResponse = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetch-only-taskuser/${userId}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                setUsers(usersResponse.data.users);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchData();
    }, [accessToken]);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const response = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetchallbrands`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                setBrands(response.data || []);
            } catch (error) {
                console.error("Error fetching brands:", error);
            }
        };
        fetchBrands();
    }, [accessToken]);

    const loadProjectsForBrand = async (brandId) => {
        const brand = brands.find((b) => String(b.brand_id) === String(brandId));
        if (!brand) {
            setProjects([]);
            return;
        }
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/projectRoutes/projects-by-brand`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params: { brand_name: brand.brand_name },
                }
            );
            setProjects(response.data?.projects || []);
        } catch (error) {
            console.error("Error fetching projects:", error);
            setProjects([]);
        }
    };

    const handleBrandChange = async (e) => {
        const brandId = e.target.value;
        setSelectedBrandId(brandId);
        setSelectedProject("");
        if (!brandId) {
            setProjects([]);
            return;
        }
        await loadProjectsForBrand(brandId);
    };

    const handleTaskFormChange = async (index, key, value) => {
        const updatedForms = [...taskForms];
        updatedForms[index][key] = value;

        // Check if either `user_id` or `task_startdate` is being changed
        if (key === "user_id" || key === "task_startdate") {
            const { user_id, task_startdate } = updatedForms[index];

            if (user_id && task_startdate) {
                try {
                    const response = await axios.get(
                        `${config.apiBASEURL}/projectRoutes/fetch-all-task-users`,
                        {
                            headers: { Authorization: `Bearer ${accessToken}` },
                            params: {
                                user_id: user_id,
                                start_date: task_startdate
                            }, // Pass query parameters here
                        }
                    );

                    const usersData = response.data;

                    // Find the user details using the user_id
                    const userDetails = usersData.find(
                        (user) => user.user_id === parseInt(user_id, 10)
                    );

                    updatedForms[index].userDetails = userDetails || null;
                } catch (error) {
                    console.error("Error fetching user details:", error);
                    updatedForms[index].userDetails = null; // Clear details on error
                }
            } else {
                // Clear details if inputs are incomplete
                updatedForms[index].userDetails = null;
            }
        }

        // Update the state outside the conditional block
        setTaskForms(updatedForms);
    };



    const addTaskForm = () => {
        setTaskForms([createEmptyTaskForm(), ...taskForms]);
    };

    const removeTaskForm = (index) => {
        const updatedForms = taskForms.filter((_, i) => i !== index);
        setTaskForms(updatedForms);
    };

    const handleTaskSubmit = async (e) => {
        e.preventDefault();
        const projectId = selectedProject ? Number(selectedProject) : null;
        const project = projects.find((p) => Number(p.project_id) === projectId);
        const brandId = project?.brand_id != null
            ? Number(project.brand_id)
            : selectedBrandId
                ? Number(selectedBrandId)
                : null;

        if (!brandId || !projectId) {
            setValidationMessage('Please choose a brand and project from the dropdowns.');
            setShowValidationDialog(true);
            return;
        }

        const tasksWithBrandAndProject = taskForms.map((task) => ({
            ...task,
            brand_id: brandId,
            project_id: projectId,
        }));
        setLoading(true);
        try {
            await axios.post(
                `${config.apiBASEURL}/projectRoutes/add-tasks`,
                { tasks: tasksWithBrandAndProject },
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            // Show video dialog
            setVideoDialogVisible(true);
            setTimeout(() => {
                // Hide video dialog after 5 seconds
                setVideoDialogVisible(false);

                // Navigate to the admin task board
                navigate("/Graphe/dashboard/task_board_admin");
            }, 5000);
        } catch (error) {
            console.error("Error adding tasks:", error);
        }
        setLoading(false);
    };

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col md={12} className="mb-3">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Add Tasks</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={12}>
                        <Card>
                            <Card.Header className="sticky-top bg-light shadow-sm" style={{ top: '-40px' }}>
                                <div className="d-flex justify-content-between">
                                    <Form.Group className="w-50 mx-2">
                                        <Form.Label>Brand</Form.Label>
                                        <Form.Select
                                            value={selectedBrandId}
                                            onChange={handleBrandChange}
                                        >
                                            <option value="">Select Brand</option>
                                            {brands.map((brand) => (
                                                <option key={brand.brand_id} value={brand.brand_id}>
                                                    {brand.brand_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="w-50 mx-2">
                                        <Form.Label>Project</Form.Label>
                                        <Form.Select
                                            value={selectedProject}
                                            onChange={(e) => setSelectedProject(e.target.value)}
                                            disabled={!selectedBrandId}
                                        >
                                            <option value="">Select Project</option>
                                            {projects.map((project) => (
                                                <option key={project.project_id} value={project.project_id}>
                                                    {project.project_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </div>

                            </Card.Header>
                            {selectedProject && (
                                <Card.Body>
                                    <div className="d-flex justify-content-end mb-3">
                                        <Button
                                            severity="primary"
                                            outlined
                                            label="Add Task"
                                            icon="pi pi-plus"
                                            className="py-2 me-2"
                                            onClick={addTaskForm}
                                        />
                                        <Button
                                            severity="success"
                                            label={loading ? 'Saving...' : 'Save All'}
                                            icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                                            className="py-2 border-0"
                                            onClick={handleTaskSubmit}
                                            disabled={loading}
                                        />
                                    </div>
                                    <Row>

                                        {taskForms.map((task, index) => (
                                            <div key={index} className="mb-2 border p-3 oddBox">
                                                <div className="d-flex justify-content-between align-items-center position-relative">
                                                    <h6 className="cardNum">{index + 1}</h6>
                                                    <Button
                                                        severity="danger"
                                                        title="Remove Task"
                                                        icon="pi pi-times"
                                                        rounded
                                                        className="p-0 border-0"
                                                        onClick={() => removeTaskForm(index)}
                                                        style={{ position: "absolute", right: '-25px', top: '-20px', fontSize: '15px' }}
                                                    />
                                                </div>
                                                <Row>
                                                    <Col md={6} lg={4} className="mb-3">
                                                        {task.userDetails ? (
                                                            <Card className="shadow-0 bg-transparent border-end">
                                                                <Card.Header className="border-bottom ps-0 position-relative">
                                                                    <div className="d-flex align-items-center">
                                                                        <Avatar className="me-2"
                                                                            image={task.userDetails.profile_image}
                                                                            shape="circle"
                                                                            size="large"
                                                                        />
                                                                        <p className="mb-0" style={{ lineHeight: '1.3' }}>
                                                                            <b>{task.userDetails.first_name} {task.userDetails.last_name}</b>
                                                                            <small className="d-block text-secondary">{task.userDetails.user_type}</small>
                                                                        </p>
                                                                    </div>
                                                                    <p style={{ position: 'absolute', right: '20px', top: '0' }}>
                                                                        {task.userDetails.limit_exceeded ? (
                                                                            <>
                                                                                <FaUserTimes className="text-danger" title="Limit  Exceeded" />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <FaUserCheck className="text-success" title="Limit Not Exceeded" />
                                                                            </>
                                                                        )}
                                                                    </p>
                                                                </Card.Header>
                                                                <Card.Body className="ps-0">
                                                                    <ul className="totaltaskUseral">
                                                                        <li>
                                                                            <small>Max <sub>/ Per Day</sub></small> {task.userDetails.max_tasks_per_day}
                                                                        </li>
                                                                        <li>
                                                                            <small> Allocated <sub>/ Selected Day</sub></small> {task.userDetails.tasks_today}
                                                                        </li>
                                                                        <li>
                                                                            <small>Remaining </small> {task.userDetails.remaining_tasks}
                                                                        </li>
                                                                    </ul>

                                                                    <p style={{ fontSize: '14px' }} className="mt-4">
                                                                        <small> <em><b>Info :</b></em> Dont Assign more than Permitted else excess tasks wont Be Submitted</small>
                                                                    </p>

                                                                </Card.Body>
                                                            </Card>
                                                        ) : (
                                                            <p>Select a user to view details</p>
                                                        )}
                                                    </Col>
                                                    <Col md={6} lg={8} className="mb-3">
                                                        <Row>
                                                            <Col md={6} lg={8} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Task Name</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={task.task_name}
                                                                        onChange={(e) => handleTaskFormChange(index, 'task_name', e.target.value)}
                                                                        required
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Task Type</Form.Label>
                                                                    <Form.Control
                                                                        as="select"
                                                                        value={task.task_type || 'Graphe'}
                                                                        onChange={(e) => handleTaskFormChange(index, 'task_type', e.target.value)}
                                                                    >
                                                                        <option value="Graphe">Graphe</option>
                                                                        <option value="Weddings">Weddings</option>
                                                                        <option value="MoGraph">MoGraph</option>
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Assign To</Form.Label>
                                                                    <Form.Select
                                                                        value={task.user_id}
                                                                        onChange={(e) => handleTaskFormChange(index, 'user_id', e.target.value)}
                                                                    >
                                                                        <option value="">Select User</option>
                                                                        {users.map((user) => (
                                                                            <option key={user.user_id} value={user.user_id}>
                                                                                {user.first_name} {user.last_name}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Start Date and Time</Form.Label>
                                                                    <Calendar
                                                                        value={task.task_startdate}
                                                                        onChange={(e) => handleTaskFormChange(index, 'task_startdate', e.value)}
                                                                        showTime
                                                                        hourFormat="12" // Use "12" for 12-hour format with AM/PM
                                                                        dateFormat="dd-mm-yy"
                                                                        placeholder="Select Date and Time"
                                                                        required
                                                                        className="p-inputtext-sm" // Optional: Smaller input size
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Deadline Date and Time</Form.Label>
                                                                    <Calendar
                                                                        value={task.task_deadline}
                                                                        onChange={(e) => handleTaskFormChange(index, 'task_deadline', e.target.value)}
                                                                        showTime
                                                                        hourFormat="12" // Use "12" for 12-hour format with AM/PM
                                                                        dateFormat="dd-mm-yy"
                                                                        placeholder="Select Date and Time"
                                                                        required
                                                                        className="p-inputtext-sm" // Optional: Smaller input size
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} lg={4} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Priority</Form.Label>
                                                                    <Form.Select
                                                                        value={task.priority}
                                                                        onChange={(e) => handleTaskFormChange(index, 'priority', e.target.value)}
                                                                    >
                                                                        <option value="Low">Low</option>
                                                                        <option value="Medium">Medium</option>
                                                                        <option value="High">High</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={12} lg={8}>
                                                                <Form.Group>
                                                                    <Form.Label>Task Description</Form.Label>
                                                                    <InputTextarea
                                                                        value={task.task_description}
                                                                        onChange={(e) => handleTaskFormChange(index, 'task_description', e.target.value)}
                                                                        autoResize
                                                                        className="w-100"
                                                                        placeholder="Enter task description"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                </Row>
                                            </div>
                                        ))}

                                    </Row>
                                </Card.Body>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Row>
            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>
            <Dialog
                header="Required fields"
                visible={showValidationDialog}
                onHide={() => setShowValidationDialog(false)}
                modal
                style={{ width: '420px' }}
                footer={
                    <Button
                        label="OK"
                        icon="pi pi-check"
                        onClick={() => setShowValidationDialog(false)}
                    />
                }
            >
                <p className="mb-0">{validationMessage}</p>
            </Dialog>
        </>
    );
};


export default Add_employee_task;
